<template>
  <v-dialog v-model="open">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn v-bind="activatorProps">Request Edit</v-btn>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card>
        <v-card-title>Records Edit Request</v-card-title>
        <v-card-text>for {{ person.lastname }}, {{ person.firstname }}</v-card-text>

        <v-card-item><v-text-field type="name" v-model="data.contactname" label="Your Name"/></v-card-item>
        <v-card-item><v-text-field type="tel" v-model="data.contactphone" label="Contact Phone"/></v-card-item>
        <v-card-item><v-text-field type="email" v-model="data.contactemail" label="Contact Email"/></v-card-item>
        <v-card-item><v-textarea v-model="data.notes" label="Request"/></v-card-item>

        <v-card-actions>
          <v-spacer />
          <v-btn text="Close" @click="isActive.value = false" />
          <v-btn text="Submit" @click="addRequest()" />
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>

  <v-snackbar v-model="success" color="green"><b>Change Request Submitted!</b></v-snackbar>
</template>

<script>

export default {
  name: 'AddChangeRequestDialog.vue',

  props:{
    person : Object
  },

  data: () => ({
    data : {
      peopleid : -1,
      cemeteryid : -1,
      contactname : "",
      contactphone : "",
      contactemail : "",
      notes : "",
    },
    open : false,
    success : false
  }),

  created : function(){
    this.data.peopleid = this.person.id;
    this.data.cemeteryid = this.person.cemeteryid;
  },

  methods:{
    addRequest(){
      fetch("https://app.cemeterycommunity.com:11000/api/addgenealogychangerequest", { method: "POST", headers : { data : JSON.stringify(this.data) } })
      .then( res => res.json() )
      .then( res =>  {
        if(res.results != "Failed" && res.results.length > 0){
          this.open = false
          this.success = true;
        }
      });
    }
  }
}
</script>